/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();

      this.giftProductContainer = this.querySelector('[data-role="gift--product"]');
      this.giftSizeSelector = this.querySelector('[data-role="select-gift-variant"]');
      this.giftProductSelector = this.querySelector('#gift-products-list');
      this.giftProductImage = this.querySelector('.gift--product__image img');
      this.giftProductPrice = this.giftProductContainer.querySelector('.default--price');
      this.giftInCart = document.querySelector('[data-role="gift-product"]');

      if (this.giftProductSelector) {
        this.giftProductSelector.addEventListener('change', (e) => {
          const selectedOption = e.target.options[e.target.selectedIndex];
          const productImage = selectedOption.getAttribute('data-product-image');
          const productTitle = selectedOption.getAttribute('data-product-name');

          this.currentProductId = e.target.value;

          this.updateProductTitle(productTitle);
          this.updatePrice(selectedOption.dataset.productPrice);
          this.updateAvailableVariants(e.target.value);
          this.updateProductImage(productImage);
        });
      }

      this.giftProductContainer &&
      this.giftSizeSelector.addEventListener('change', async (e) => {
        const {value} = e.target;

        if (this.giftInCart) {
          await this.removeGiftProduct();
        }

        let formData = {
          items: [
            {
              id: value,
              quantity: 1,
              properties: {_is_gift: true},
            },
          ],
        };

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Error ${response.statusText}`);
            }

            this.refreshCart();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      });
    }

    connectedCallback() {
      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');


      if (this.giftProductSelector && this.giftSizeSelector) {
        this.updateAvailableVariants(this.giftProductSelector.value);
      }

      if (this.giftInCart && this.giftSizeSelector) {
        // this.giftSizeSelector.classList.add('visually-hidden');
      }

      if (this.giftInCart && this.giftProductSelector) {
        this.giftProductSelector.classList.add('visually-hidden');
        this.giftProductSelector.closest('.gift-products-list-form-group')?.classList.add('visually-hidden');
      }

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || '${{amount}}';
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'flex';
        this.fullText.style.display = 'none';
        this.giftProductContainer && this.giftProductContainer.classList.add('visually-hidden');

        if (this.giftInCart) {
          this.removeGiftProduct();
        }
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'flex';
        this.giftProductContainer && this.giftProductContainer.classList.remove('visually-hidden');
      }

      this.style.setProperty('--percentage', percentage);
    }

    updateProductTitle(title) {
      const titleElement = this.giftProductContainer.querySelector('.js-gift-product-title');
      titleElement.innerHTML = title;
    }

    get currentProductId() {
      return this.giftProductContainer.dataset.currentProductId || null;
    }

    set currentProductId(value) {
      this.giftProductContainer.dataset.currentProductId = value;
      return value;
    }

    updatePrice(price) {
      if (!this.giftProductPrice || !price) return;
      this.giftProductPrice.innerHTML = price;
    }

    updateAvailableVariants(selectedProductId) {
      if (!this.giftSizeSelector) return;

      if (!this.allVariantOptions) {
        this.allVariantOptions = Array.from(
          this.giftSizeSelector.querySelectorAll('option[data-main-product-id]')
        );
      }

      this.giftSizeSelector.value = '';

      const placeholder = this.giftSizeSelector.querySelector('option[value=""]');

      this.giftSizeSelector.innerHTML = '';

      if (placeholder) {
        this.giftSizeSelector.appendChild(placeholder);
      }

      this.allVariantOptions.forEach(option => {
        const optionProductId = option.getAttribute('data-main-product-id');

        if (optionProductId === this.currentProductId) {
          this.giftSizeSelector.appendChild(option.cloneNode(true));
        }
      });
    }

    updateProductImage(imageUrl) {
      if (!this.giftProductImage || !imageUrl) return;
      this.giftProductImage.src = imageUrl;
      this.giftProductImage.srcset = imageUrl;
    }

    refreshCart() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            console.log({section});
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            console.log({elementToReplace});

            if (elementToReplace) elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          });
        });
    }

    async removeGiftProduct() {
      const line = this.giftInCart.dataset.line;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line,
            quantity: 0,
          }),
        });

        if (!response.ok) {
          throw new Error(`Error ${response.statusText}`);
        }

        console.log('Gift product was removed from cart', response);
        this.refreshCart();
      } catch (error) {
        console.error('Error:', error);
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
